import React from 'react';

export const EditViewContext = React.createContext({
    edit: null,
    onChangeEditMode: value => {},
    onChange: (name, value) => {},
  });